import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { MAX_TYPING_INDICATOR_MS } from '@/config/constants';
import { cn } from '@/lib/utils';
import { ErrorPage } from '@/newComponents/ErrorPage';
import { LoadingPage } from '@/newComponents/LoadingPage';
import { WelcomeFields } from '@/newComponents/WelcomeFields/WelcomeFields';
import { widgetAlignmentSelector, widgetPositionState } from '@/state/config';
import { composeSelector, composeState, errorSessionSelector, isMobileState, chatEventCountSelector, showWelcomeFormSelector, isWidgetExpandedState, } from '@/state/session';
import { isLoadingSelector } from '@/state/socket';
import { Header } from '../Header/Header';
import { Chat } from './Chat';
const baseStyles = 'chatContainer bg-background ';
const layoutStyles = {
    base: 'shadow-sm max-h-screen dark:border dark:border-input',
    fullScreen: 'h-full w-full overflow-hidden',
    mobile: 'bottom-0 w-full rounded-none bg-[var(--text-03)] opacity-100',
};
const positionStyles = {
    livechat: 'fixed right-0 bottom-16 h-[var(--moveo-chat-height)] max-h-[calc(100vh-80px)] w-[var(--moveo-chat-width)] overflow-hidden rounded-[var(--moveo-new-border-radius-base)] transition-[width] duration-100 ease-in-out animate-in fade-in slide-in-from-bottom-4 fade-out slide-out-to-bottom-4 duration-300',
    expanded: 'w-[var(--moveo-expanded-chat-width)]',
    leftAligned: 'left-0',
};
export const ChatContainer = () => {
    const timerRef = useRef();
    const widgetAlignment = useRecoilValue(widgetAlignmentSelector);
    const setCompose = useSetRecoilState(composeState);
    const compose = useRecoilValue(composeSelector);
    const { isLivechat, isPopup, isEmbed } = useRecoilValue(widgetPositionState);
    const isMobile = useRecoilValue(isMobileState);
    const error = useRecoilValue(errorSessionSelector);
    const chatEventsCount = useRecoilValue(chatEventCountSelector);
    const showWelcomeForm = useRecoilValue(showWelcomeFormSelector);
    const isLoading = useRecoilValue(isLoadingSelector);
    const isWidgetExpanded = useRecoilValue(isWidgetExpandedState);
    // Disable compose after 10 seconds of innactivity(MAX_TYPING_INDICATOR_MS)
    useEffect(() => {
        if (!!compose && chatEventsCount) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = window.setTimeout(() => {
                setCompose(null);
            }, MAX_TYPING_INDICATOR_MS);
        }
        else {
            clearTimeout(timerRef.current);
        }
    }, [chatEventsCount, compose, setCompose]);
    const getPositionStyles = () => {
        if (isLivechat && !isMobile) {
            return cn(positionStyles.livechat, isWidgetExpanded && positionStyles.expanded, widgetAlignment === 'left' && positionStyles.leftAligned);
        }
        if (isPopup) {
            return cn(layoutStyles.fullScreen, isMobile && 'rounded-none');
        }
        if (isEmbed) {
            return layoutStyles.fullScreen;
        }
        return '';
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { className: cn(baseStyles, layoutStyles.base, getPositionStyles(), {
                [layoutStyles.mobile]: isMobile && isLivechat,
            }), children: [_jsx(Header, {}), error && _jsx(ErrorPage, {}), !error && !isLoading && showWelcomeForm && _jsx(WelcomeFields, {}), !error && !isLoading && !showWelcomeForm && _jsx(Chat, {}), !error && isLoading && _jsx(LoadingPage, {})] }) }));
};
